import React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

export function Tabs({ defaultValue, value, onValueChange, children, className = '', ...props }) {
  return (
    <TabsPrimitive.Root defaultValue={defaultValue} value={value} onValueChange={onValueChange} className={className} {...props}>
      {children}
    </TabsPrimitive.Root>
  );
}

export function TabsList({ children, className = '' }) {
  return (
    <TabsPrimitive.List className={`flex gap-2 p-1 bg-[var(--color-inerva-mint)]/30 rounded-full ${className}`}>
      {children}
    </TabsPrimitive.List>
  );
}

export function TabsTrigger({ value, children, className = '' }) {
  return (
    <TabsPrimitive.Trigger
      value={value}
      className={`px-5 py-2.5 text-sm font-medium rounded-full transition-all duration-300 text-[var(--color-inerva-text-light)] hover:text-[var(--color-inerva-forest)] data-[state=active]:bg-white data-[state=active]:text-[var(--color-inerva-forest)] data-[state=active]:shadow-sm ${className}`}
    >
      {children}
    </TabsPrimitive.Trigger>
  );
}

export function TabsContent({ value, children, className = '' }) {
  return (
    <TabsPrimitive.Content value={value} className={`mt-6 ${className}`}>
      {children}
    </TabsPrimitive.Content>
  );
}

export default Tabs;
